import { ApiClient } from './_api';
import { ApiHooks } from './apiHooks';
import { apiClient } from './clientApi';
import { EndpointIDs } from './endpointIDs';

/**
 * APIHooks - endpoint settings
 * ----------------------------------------------------------
 * Define endpoint level settings for queries and mutations.
 * These will override the application level settings in `create.ts`, but can be overridden at hook execution level
 */
export const hookConfigFactory: ApiHooks.HookConfigLibraryFactory<ApiClient> = empty => {
  const endpointSettings = { ...empty };

  return endpointSettings;
};
/**
 * APIHooks - default data
 * ----------------------------------------------------------
 * Optionally define some default data for each real endpoint for testing purposes.
 * This data will be used on first render of a component using this endpoint, and a real request will never be fired.
 * These objects will be used on first render if `useDefaultData` is set to `true` at system, application or endpoint level
 * Each endpoint:
 * - Receives the typed arguments from the request
 * - Should return an object of the correct response type
 */
const defaultDataFactory: ApiHooks.DefaultDataLibraryFactory<ApiClient> = empty => {
  const defaultData = { ...empty };

  /** Example */
  /**
   * defaultData.myController.myEndpoint = args => {
   *   return { data: {} };
   * }
   */

  return defaultData;
};

/**
 * APIHooks - mock endpoints
 * ----------------------------------------------------------
 * Optionally define a mock endpoint for each real endpoint for testing purposes.
 * These endpoints will be used by all queries and mutations if `useMockEndpoints` is set to `true` at system, application or endpoint level
 * Each endpoint:
 * - Receives the typed arguments from the request
 * - Should return a promise of the correct response object
 */
export const mockEndpointFactory: ApiHooks.MockEndpointLibraryFactory<ApiClient> = empty => {
  const mockEndpoints = { ...empty };

  /** Example */
  /**
   * mockEndpoints.myController.myEndpoint = async args => {
   *   return Promise.resolve({ data: {} });
   * }
   */

  return mockEndpoints;
};

export const endpointIds = EndpointIDs.create(apiClient);

/**
 * APIHooks - root creation point + application level settings
 * -------------------------------------
 * Application level query and mutation settings go here, but can be overridden at endpoint level in `endpointSettings.ts`
 */
export const apiHooks = ApiHooks.create(apiClient, {
  generalConfig: {
    debugMode: false, // APP_CONFIG.isDebug,
  },
  queryConfig: {
    caching: {
      staleOnErrorIfOlderThan: 'always',
      fetchInBackground: false,
      staleIfOlderThan: 'always',
    },
    autoInvoke: true,
  },
  mutationConfig: {
    throwErrors: false,
  },
  hookConfigFactory,
  mockEndpointFactory,
  defaultDataFactory,
});
